document.addEventListener('DOMContentLoaded', function() {
  // Sélectionne le conteneur du slider via l'ID qui commence par "MyCustomSliderContainer-"
  const sliderContainer = document.querySelector('[id^="MyCustomSliderContainer-"]');
  if (!sliderContainer) return;

  const slideList = sliderContainer.querySelector('.mycustom-slide-list');
  const slides = sliderContainer.querySelectorAll('.mycustom-slide');
  const totalSlides = slides.length;
  const gap = 10; // Devrait correspondre à la valeur du gap du CSS

  // Sélection des éléments de navigation (flèches et dots)
  const prevArrow = document.querySelector('.mycustom-arrow--prev');
  const nextArrow = document.querySelector('.mycustom-arrow--next');
  const dots = document.querySelectorAll('.mycustom-dot');

  let currentIndex = 0;

  // Fonction pour récupérer la largeur de la slide (basée sur la largeur du conteneur)
  function getSlideWidth() {
    return sliderContainer.offsetWidth;
  }

  // Met à jour la position du slider en appliquant une translation
  function updateSliderPosition(withTransition = true) {
    const slideWidth = getSlideWidth();
    // Calcul de l'offset en tenant compte du gap : chaque slide occupe (slideWidth + gap)
    const offset = -(currentIndex * (slideWidth + gap));
    slideList.style.transition = withTransition ? 'transform 0.8s cubic-bezier(0.25, 0.1, 0.25, 1)' : 'none';
    slideList.style.transform = `translateX(${offset}px)`;
    
    // Met à jour l'état des points
    dots.forEach((dot, i) => {
      if (i === currentIndex) {
        dot.classList.add('mycustom-dot-active');
      } else {
        dot.classList.remove('mycustom-dot-active');
      }
    });
  }
  
  // Initialiser la position du slider
  updateSliderPosition();

  // Fonction de changement de slide (non-cyclique)
  function showSlide(index) {
    if (index < 0) {
      currentIndex = 0;
    } else if (index >= totalSlides) {
      currentIndex = totalSlides - 1;
    } else {
      currentIndex = index;
    }
    updateSliderPosition();
  }

  // Écouteurs sur les flèches
  if (prevArrow) {
    prevArrow.addEventListener('click', () => {
      showSlide(currentIndex - 1);
    });
  }
  if (nextArrow) {
    nextArrow.addEventListener('click', () => {
      showSlide(currentIndex + 1);
    });
  }
  
  // Écouteurs sur les points (dots)
  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => {
      showSlide(i);
    });
  });
  
  // Gestion du swipe tactile avec effet "dragging" en temps réel
  let startX = 0;
  let isDragging = false;
  sliderContainer.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    isDragging = true;
    slideList.style.transition = 'none'; // Désactive la transition pendant le drag
  });
  
  sliderContainer.addEventListener('touchmove', (e) => {
    if (!isDragging) return;
    const currentX = e.touches[0].clientX;
    const deltaX = currentX - startX;
    const slideWidth = getSlideWidth();
    const baseOffset = -(currentIndex * (slideWidth + gap));
    const translateX = baseOffset + deltaX;
    slideList.style.transform = `translateX(${translateX}px)`;
  });
  
  sliderContainer.addEventListener('touchend', (e) => {
    if (!isDragging) return;
    isDragging = false;
    const endX = e.changedTouches[0].clientX;
    const deltaX = endX - startX;
    const slideWidth = getSlideWidth();
    const threshold = slideWidth * 0.2;  // Seuil de 20% de la largeur
    if (deltaX < -threshold) {
      showSlide(currentIndex + 1);
    } else if (deltaX > threshold) {
      showSlide(currentIndex - 1);
    } else {
      updateSliderPosition();
    }
  });
});